import { AUTOMATIC } from "../actions";

const defaultState = {
  filters: [],
  pageIndex: 0,
  sort: "",
  desc: false,
  loading: false,
  error: false,
  tabIndex: 0
};

const fetch = state => ({ ...state, loading: true, error: false });
const fetchSuccess = (state, action) => ({
  ...state,
  loading: false,
  error: false,
  prevalidated: action.payload
});
const fetchError = state => ({ ...state, loading: false, error: true });

const setFilters = (state, { payload }) => ({ ...state, filters: payload });
const setPageIndex = (state, { payload }) => ({ ...state, pageIndex: payload });
const setSortColumn = (state, { payload }) => ({ ...state, sort: payload });
const setSortDesc = (state, { payload }) => ({ ...state, desc: payload });
const setTabIndex = (state, { payload }) => ({ ...state, tabIndex: payload });
const ACTION_HANDLERS = {
  [AUTOMATIC.FETCH]: fetch,
  [AUTOMATIC.FETCH_SUCCESS]: fetchSuccess,
  [AUTOMATIC.FETCH_ERROR]: fetchError,
  [AUTOMATIC.SET_FILTER]: setFilters,
  [AUTOMATIC.SET_PAGE_INDEX]: setPageIndex,
  [AUTOMATIC.SET_SORT_COLUMN]: setSortColumn,
  [AUTOMATIC.SET_SORT_DESC]: setSortDesc,
  [AUTOMATIC.SET_TAB_INDEX]: setTabIndex
};

export default (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
